const provinceMap = [
  {
    "groupName": "A-G",
    "list": [
      {
        "AdCode": "11",
        "name": "北京市",
        "shortName": "北京",
        "municipality": true
      },
      {
        "AdCode": "34",
        "name": "安徽省",
        "shortName": "安徽"
      },
      {
        "AdCode": "35",
        "name": "福建省",
        "shortName": "福建"
      },
      {
        "AdCode": "44",
        "name": "广东省",
        "shortName": "广东"
      },
      {
        "AdCode": "45",
        "name": "广西壮族自治区",
        "shortName": "广西"
      },
      {
        "AdCode": "52",
        "name": "贵州省",
        "shortName": "贵州"
      },
      {
        "AdCode": "62",
        "name": "甘肃省",
        "shortName": "甘肃"
      }
    ]
  },
  {
    "groupName": "T-Z",
    "list": [
      {
        "AdCode": "12",
        "name": "天津市",
        "shortName": "天津",
        "municipality": true
      },
      {
        "AdCode": "33",
        "name": "浙江省",
        "shortName": "浙江"
      },
      {
        "AdCode": "50",
        "name": "重庆市",
        "shortName": "重庆",
        "municipality": true
      },
      {
        "AdCode": "53",
        "name": "云南省",
        "shortName": "云南"
      },
      {
        "AdCode": "54",
        "name": "西藏自治区",
        "shortName": "西藏"
      },
      {
        "AdCode": "65",
        "name": "新疆维吾尔自治区",
        "shortName": "新疆"
      }
    ]
  },
  {
    "groupName": "H-K",
    "list": [
      {
        "AdCode": "13",
        "name": "河北省",
        "shortName": "河北"
      },
      {
        "AdCode": "22",
        "name": "吉林省",
        "shortName": "吉林"
      },
      {
        "AdCode": "23",
        "name": "黑龙江省",
        "shortName": "黑龙江"
      },
      {
        "AdCode": "32",
        "name": "江苏省",
        "shortName": "江苏"
      },
      {
        "AdCode": "36",
        "name": "江西省",
        "shortName": "江西"
      },
      {
        "AdCode": "41",
        "name": "河南省",
        "shortName": "河南"
      },
      {
        "AdCode": "42",
        "name": "湖北省",
        "shortName": "湖北"
      },
      {
        "AdCode": "43",
        "name": "湖南省",
        "shortName": "湖南"
      },
      {
        "AdCode": "46",
        "name": "海南省",
        "shortName": "海南"
      }
    ]
  },
  {
    "groupName": "L-S",
    "list": [
      {
        "AdCode": "14",
        "name": "山西省",
        "shortName": "山西"
      },
      {
        "AdCode": "15",
        "name": "内蒙古自治区",
        "shortName": "内蒙古"
      },
      {
        "AdCode": "21",
        "name": "辽宁省",
        "shortName": "辽宁"
      },
      {
        "AdCode": "31",
        "name": "上海市",
        "shortName": "上海",
        "municipality": true
      },
      {
        "AdCode": "37",
        "name": "山东省",
        "shortName": "山东"
      },
      {
        "AdCode": "51",
        "name": "四川省",
        "shortName": "四川"
      },
      {
        "AdCode": "61",
        "name": "陕西省",
        "shortName": "陕西"
      },
      {
        "AdCode": "63",
        "name": "青海省",
        "shortName": "青海"
      },
      {
        "AdCode": "64",
        "name": "宁夏回族自治区",
        "shortName": "宁夏"
      }
    ]
  }
]

// 直辖市
const municipalityGroup = ['北京市', '上海市', '天津市', '重庆市']

export {
  provinceMap,
  municipalityGroup
}
